var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { withRouter } from "react-router";
import id from "@irati/utils/id";
import Loading from "@irati/ui/src/Loading";
import History from "@irati/utils/history";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import session from "@irati/auth/services/session";
import FullLogin from "./DefaultLogin/FullLogin";
import LoginOnlySSO from "./DefaultLogin/LoginOnlySSO";
var DefaultLogin = /** @class */ (function (_super) {
    __extends(DefaultLogin, _super);
    function DefaultLogin(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.getSessionPostData = function () {
            var load = session
                .getThenRemove(["email"])
                .then(function (data) {
                if (data && data.email) {
                    var email = data.email;
                    _this.setState({ email: email });
                }
            })
                .catch(function () {
                /* no-op, fail silently */
            });
            return load;
        };
        _this.redirectBackTo = function () {
            var nextPathname = get(_this.props, "location.state.nextPathname", "");
            var isLogin = nextPathname === location.pathname;
            if (!nextPathname || isLogin) {
                return null;
            }
            var _a = _this.context.apps, PUBLIC = _a.PUBLIC, ONBOARDING = _a.ONBOARDING;
            if (nextPathname.includes(PUBLIC) || nextPathname.includes(ONBOARDING)) {
                return null;
            }
            return nextPathname;
        };
        _this.handleContinue = function () {
            var backTo = _this.redirectBackTo();
            if (backTo) {
                History.replace(backTo);
            }
            else {
                History.replace({
                    pathname: "/"
                });
            }
        };
        _this.state = {
            email: "",
            load: _this.getSessionPostData(),
            submit: null
        };
        return _this;
    }
    DefaultLogin.prototype.render = function () {
        var _a = this.state, load = _a.load, email = _a.email;
        var formatMessage = this.props.formatMessage;
        var business = authentication.unAuthedBusiness();
        var idNamespace = id("default-login", this.props);
        var isSSO = business.showSsoLogin;
        var onlySSO = isSSO && !business.showPasswordLogin;
        var ssoButtonText = business.loginPageSsoButtonText || formatMessage({ id: "platform.defaultLogin.fields.button.singleSignOn" });
        var headerOne = React.createElement(FormattedMessage, { id: "platform.defaultLogin.headerOne.text" });
        var headerTwo = (React.createElement(FormattedMessage, { id: "platform.defaultLogin.headerTwo.text", values: { tenantName: business.businessName || "Perkbox" } }));
        return (React.createElement(Loading, { load: load },
            onlySSO && (React.createElement(LoginOnlySSO, { idNamespace: idNamespace, headerOne: headerOne, headerTwo: headerTwo, onContinue: this.handleContinue, text: ssoButtonText })),
            !onlySSO && (React.createElement(FullLogin, { id: idNamespace, onContinue: this.handleContinue, postedEmail: email, headerOne: headerOne, headerTwo: headerTwo, ssoButtonText: ssoButtonText }))));
    };
    DefaultLogin.contextTypes = {
        appPath: PropTypes.string.isRequired,
        apps: PropTypes.object.isRequired
    };
    return DefaultLogin;
}(Component));
export default withRouter(DefaultLogin);
